module.exports = __webpack_public_path__ + "static/media/KawaiiFood.f111f2a3.ttf";